import React from 'react';

const Topbar: React.FC = () => {
  return (
    <div className="bg-dark py-2 hidden md:block">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <small className="text-gray-400 text-sm">
              <a href="#" className="hover:text-secondary transition">
                <i className="fas fa-map-marker-alt mr-2 text-secondary"></i>
                26/6 Paris Town Batala Road, Amritsar
              </a>
            </small>
            <small className="text-gray-400 text-sm">
              <a href="#" className="hover:text-secondary transition">
                <i className="fas fa-envelope mr-2 text-secondary"></i>
                support@nexedz.org
              </a>
            </small>
          </div>
          
          <div className="hidden xl:block">
            <small className="text-secondary">
              Note : Growing Your Business, Together
            </small>
          </div>
          
          <div className="flex space-x-2">
            <a href="https://www.facebook.com/share/17eckxGt9w/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="bg-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-secondary transition">
              <i className="fab fa-facebook-f text-primary text-sm"></i>
            </a>
            <a href="https://youtube.com/@nexedz-selfreliantbharat" target="_blank" rel="noopener noreferrer" className="bg-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-secondary transition">
              <i className="fab fa-youtube text-primary text-sm"></i>
            </a>
            <a href="https://www.instagram.com/nexedz_private_limited" target="_blank" rel="noopener noreferrer" className="bg-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-secondary transition">
              <i className="fab fa-instagram text-primary text-sm"></i>
            </a>
            <a href="https://www.linkedin.com/company/nexedz" target="_blank" rel="noopener noreferrer" className="bg-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-secondary transition">
              <i className="fab fa-linkedin-in text-primary text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;